export const IconFavouriteToggle = () => (
  <svg viewBox="0 0 26 25" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.123 13.45c-1.322 1.37-5.585 5.306-9.89 8.337-4.305-3.031-8.568-6.966-9.889-8.337C1.69 11.732.762 7.643 3.325 4.436c1.131-1.416 2.59-2.214 4.217-2.309.11-.006.218-.01.328-.01 1.705 0 3.414.768 4.854 2.19a.66.66 0 00.515.25.652.652 0 00.508-.255c1.53-1.509 3.364-2.278 5.178-2.174 1.628.094 3.085.893 4.216 2.308 2.564 3.207 1.636 7.296-.018 9.014"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="#4A4A4A"
      strokeWidth="1.5"
    />
  </svg>
);
